import React, { memo } from "react";
import { styled } from "@mui/system";
import cx from "classnames";

import { ContainedButton } from "./ContainedButton";

//using this button in KFS Dialog
export const Button = styled(ContainedButton)(({ theme }) => ({
  fontWeight: 500,
  letterSpacing: "normal",
  minWidth: "130px",
  borderRadius: "100px",
  [theme.breakpoints.only("md")]: {
    fontSize: "1.125rem",
    height: "unset",
    minHeight: "auto",
    padding: "12px 30px",
    lineHeight: "20px",
    "> .labelStyle": {
      fontSize: "1.125rem"
    }
  },

  "&:disabled": {
    color: theme.palette.common.white
  }
}));

export const SubmitButtonBase = ({
  justify,
  submitButtonClassName,
  type = "submit",
  isSearchApplicant = false,
  withRightArrow = true,
  ...rest
}) => (
  <div className={cx("footerCTA", submitButtonClassName)}>
    <Button
      type={type}
      isSearchApplicant={isSearchApplicant}
      withRightArrow={withRightArrow}
      {...rest}
    />
  </div>
);

export const SubmitButton = memo(SubmitButtonBase);
